import {md5} from './md5'

export function getChecksum(content: any) {
    return md5(JSON.stringify(content))
}

function sumStringChars(str: string) {
    return str
        .split('')
        .map(char => char.charCodeAt(0))
        .reduce((partialSum, a) => partialSum + a, 0)
}

export function createSignature(fixerName: string, index: number) {
    const sumOfFixerNameChars = sumStringChars(fixerName)
    return btoa(`${index}_${getChecksum({fixerName, indexAndNameSum: sumOfFixerNameChars + index})}`)
}
